import { createContext, useContext, useMemo, useState } from 'react';

const initialState = false;

export const HiddenSectionsContext = createContext({
  showHiddenSections: initialState,
  setInputState: () => {
    throw new Error('setInputState is not defined');
  },
});

export const HiddenSectionsContextProvider = ({ children }) => {
  const [showHiddenSections, setShowHiddenSections] = useState(initialState);
  const value = useMemo(
    () => ({
      showHiddenSections,
      setShowHiddenSections,
    }),
    [showHiddenSections],
  );

  return (
    <HiddenSectionsContext.Provider value={value}>
      {children}
    </HiddenSectionsContext.Provider>
  );
};

export const useHiddenSectionsContext = () => useContext(HiddenSectionsContext);
